import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgArrayGet',
  standalone: false,
})
export class SgArrayGetPipe implements PipeTransform {
  transform(array: any[], key: any): any[] | undefined {
    if (array?.length > 0) {
      return array.map((item) => item[key]);
    }
    return;
  }
}
